import React from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import LeadSourceView from '../components/version-4/viewForms/LeadSourceView'
import { useLeadSource } from '../hooks/CompanyConfiguration/useLeadSource'
import { useFeatures } from '../hooks/Features/useFeatures'
import { ROUTES } from '../shared/constants'

function ViewLeadSource() {
  const { leadSource, getLeadSource } = useLeadSource()
  const params = useParams()
  React.useEffect(() => {
    getLeadSource({ leadSourceId: params.leadSourceId })
  }, [params.leadSourceId])


  return (
    <Layout heading="Lead Source" heading2="Info" url1={ROUTES.LEADSOURCE} none>
      {leadSource ? (
        <HeaderTabLayout
          heading="Lead Source"
          content={<LeadSourceView leadSource={leadSource} />}
          view
          url={`/edit-leadSource/${params.leadSourceId}`}
        />
      ):<Loader/>}
    </Layout>
  )
}

export default ViewLeadSource
